import { FC } from 'react';
import { Box, Flex } from 'styled-system/jsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import { RadioCardType } from '@/modules/Auth/components/card/RadioCard.type.ts';
import { styled } from 'styled-system/jsx';
import { radioButton } from '@/common/components/base/input/radioButton/radioButton.recipe';

const RadioCard: FC<RadioCardType> = ({
  value,
  activeValue,
  title,
  description,
  withRadioButton=false
}) => {

    const radioButtonVariants = radioButton({
    checked: value === activeValue,
   
  });
  return (
    <Box
      borderColor={value === activeValue ? 'purple-4' : 'white'}
      backgroundColor="white"
      width="100%"
      boxShadow="0px 4px 8px 0px #BFBFBF1A"
      borderRadius="10px"
      padding="1rem"
      border="2px solid"
      cursor="pointer"
    >
      { !withRadioButton ?
      <>
      <Typography textStyle="b1" color="black-1">
        {title}
      </Typography>
      <Typography textStyle="b4" color="black-3">
        {description}
      </Typography>
      </> :
      <Flex direction={"row"} gap={24}>
    <styled.div display="flex" alignItems="center" gap="2">
      <styled.input
        type="radio"
        id={`radio-${value}`}
        className={radioButtonVariants}
        checked={value === activeValue}  
        borderColor={value === activeValue ?'purple-3' :'black-5'}
      />
    </styled.div>
    <Box>
        <Typography textStyle="b1" color="black-1">
        {title}
      </Typography>
      <Typography textStyle="b4" color="black-3">
        {description}
      </Typography>
    </Box>
     </Flex> 
}
    </Box>
  );
};

export default RadioCard;
